// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2_RDm","select":"Header_select__18Cof","clinic":"Header_clinic__DtbKi"};